module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container",
    attrs: {
      "id": "mobileViewPort"
    }
  }, [_c('div', {
    attrs: {
      "id": "mobileMode"
    }
  }, [_c('div', {
    attrs: {
      "id": "titleArea"
    }
  }, [_c('div', {
    staticClass: "titleText"
  }, [_vm._v("调课系统")]), _vm._v(" "), _c('div', {
    staticClass: "titleButton"
  }, [_c('el-button', {
    staticClass: "custom-el-button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showHomePage
    }
  }, [_c('i', {
    staticClass: "el-icon-s-home"
  }), _vm._v(" 首页\n                ")])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "queryArea"
    }
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('div', {
    staticClass: "formItem"
  }, [_c('el-select', {
    staticStyle: {
      "width": "210px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "学年学期",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.xnxqbm),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "xnxqbm", $$v)
      },
      expression: "queryForm.xnxqbm"
    }
  }, _vm._l((_vm.xnxqInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "审核状态",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.auditState),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "auditState", $$v)
      },
      expression: "queryForm.auditState"
    }
  }, _vm._l((_vm.auditInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "formItem text-center"
  }, [_c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.queryDialogVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-more"
  }), _vm._v(" 更多")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addRec
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-plus-outline"
  }), _vm._v(" 申请")])], 1)])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "queryDialog",
      "title": "查询信息",
      "width": "90%",
      "visible": _vm.queryDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.queryDialogVisible = $event
      }
    }
  }, [_c('el-row', [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "学年学期",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.xnxqbm),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "xnxqbm", $$v)
      },
      expression: "queryForm.xnxqbm"
    }
  }, _vm._l((_vm.xnxqInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-row', [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "课程名称",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleFilter.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryForm.courseName),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "courseName", $$v)
      },
      expression: "queryForm.courseName"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "班级名称",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleFilter.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryForm.className),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "className", $$v)
      },
      expression: "queryForm.className"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "申请教师",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleFilter.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryForm.teacherName),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "teacherName", $$v)
      },
      expression: "queryForm.teacherName"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "申请类型",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.applyType),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "applyType", $$v)
      },
      expression: "queryForm.applyType"
    }
  }, _vm._l((_vm.applyInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-row', [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "审核状态",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.auditState),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "auditState", $$v)
      },
      expression: "queryForm.auditState"
    }
  }, _vm._l((_vm.auditInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_vm._v("查 询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v("重 置")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.queryDialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "listArea"
    },
    on: {
      "scroll": _vm.handleScroll
    }
  }, [(_vm.tableData == null || _vm.tableData.length == 0) ? _c('div', {
    staticClass: "cardTips"
  }, [_vm._v("没有调课信息")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cardMain"
    }, [_c('div', {
      staticClass: "cardText"
    }, [_c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("申请教师：")]), _vm._v(_vm._s(item.creatorName))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("学年学期：")]), _vm._v(_vm._s(item.xnxqmc))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("课程名称：")]), _vm._v(_vm._s(item.courseName))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("班级名称：")]), _vm._v(_vm._s(item.className))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("申请类型：")]), _vm._v(_vm._s(item.applyTypeName))]), _vm._v(" "), _c('div', {
      staticClass: "auditStateImg"
    }, [_c('img', {
      attrs: {
        "src": _vm.loadStateImg(item),
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "cardInput"
    }, [(item.auditState == '-1' && item.xnxqbm == _vm.curterm) ? _c('el-button', {
      attrs: {
        "size": "small",
        "type": "warning"
      },
      on: {
        "click": function($event) {
          return _vm.modRec(item);
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-edit"
    }), _vm._v(" 编辑\n                    ")]) : _vm._e(), _vm._v(" "), (item.auditState != '-1' && item.auditAuth == '0' || item.xnxqbm != _vm.curterm) ? _c('el-button', {
      attrs: {
        "size": "small",
        "type": "info"
      },
      on: {
        "click": function($event) {
          return _vm.showDetailInfo(item);
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-tickets"
    }), _vm._v(" 详情\n                    ")]) : _vm._e(), _vm._v(" "), (item.auditAuth == '1' && item.xnxqbm == _vm.curterm) ? _c('el-button', {
      attrs: {
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.auditRec(item);
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-edit-outline"
    }), _vm._v(" 审核\n                    ")]) : _vm._e(), _vm._v(" "), (item.auditState != '-1') ? _c('el-button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.showAuditList(item);
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-document-copy"
    }), _vm._v(" 审核信息\n                    ")]) : _vm._e()], 1)])
  }), _vm._v(" "), (_vm.total > 2 && _vm.total > _vm.tableData.length) ? _c('div', {
    attrs: {
      "id": "loadingTips"
    }
  }, [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v(" 信息加载中，请稍候...\n            ")]) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "title": _vm.dialogTitle,
      "visible": _vm.dialogVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "closed": _vm.closeDialog
    }
  }, [_c('el-scrollbar', {
    ref: "mainDialogScroll",
    attrs: {
      "id": "mainDialogScroll"
    }
  }, [_c('el-form', {
    ref: "curdForm",
    attrs: {
      "model": _vm.curdForm,
      "label-width": "84px",
      "label-position": "left",
      "width": "100%"
    }
  }, [(_vm.editType == 'new' || _vm.editType == 'edit') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "申请类型",
      "prop": "applyType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择申请类型"
    },
    on: {
      "change": _vm.applyTypeChange
    },
    model: {
      value: (_vm.curdForm.applyType),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "applyType", $$v)
      },
      expression: "curdForm.applyType"
    }
  }, _vm._l((_vm.applyInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "申请教师",
      "prop": "applyTeacher"
    }
  }, [(_vm.userAuth.indexOf('@1@') == -1 || (_vm.editType != 'new' && _vm.editType != 'edit')) ? _c('span', {
    staticStyle: {
      "line-height": "40px"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.applyTeacherName))]) : _vm._e(), _vm._v(" "), (_vm.userAuth.indexOf('@1@') > -1 && (_vm.editType == 'new' || _vm.editType == 'edit')) ? _c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择申请教师"
    },
    on: {
      "change": _vm.applyTeacherChange
    },
    model: {
      value: (_vm.curdForm.applyTeacher),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "applyTeacher", $$v)
      },
      expression: "curdForm.applyTeacher"
    }
  }, _vm._l((_vm.teacherInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "专业名称",
      "prop": "majorCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": _vm.majorholder,
      "disabled": _vm.disabled_major
    },
    on: {
      "change": _vm.applyMajorChange
    },
    model: {
      value: (_vm.curdForm.majorCode),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "majorCode", $$v)
      },
      expression: "curdForm.majorCode"
    }
  }, _vm._l((_vm.majorInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "班级名称",
      "prop": "classCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": _vm.classholder,
      "disabled": _vm.disabled_class
    },
    on: {
      "change": _vm.applyClassChange
    },
    model: {
      value: (_vm.curdForm.classCode),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "classCode", $$v)
      },
      expression: "curdForm.classCode"
    }
  }, _vm._l((_vm.classInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程名称",
      "prop": "courseCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": _vm.courseholder,
      "disabled": _vm.disabled_course
    },
    on: {
      "change": _vm.applyCourseChange
    },
    model: {
      value: (_vm.curdForm.courseCode),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "courseCode", $$v)
      },
      expression: "curdForm.courseCode"
    }
  }, _vm._l((_vm.courseInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "调课原因",
      "prop": "adjustReason"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择调课原因"
    },
    on: {
      "change": _vm.adjustReasonChange
    },
    model: {
      value: (_vm.curdForm.adjustReason),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "adjustReason", $$v)
      },
      expression: "curdForm.adjustReason"
    }
  }, _vm._l((_vm.adjustReasonInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadButton),
      expression: "uploadButton"
    }],
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "size": "mini",
      "type": "success"
    },
    on: {
      "click": _vm.showUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-upload2"
  }), _vm._v(" 附件上传")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "变更理由",
      "prop": "changeReason"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请填写变更理由",
      "autoComplete": "on",
      "type": "textarea",
      "rows": 3,
      "show-word-limit": "",
      "maxlength": "500"
    },
    model: {
      value: (_vm.curdForm.changeReason),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "changeReason", $$v)
      },
      expression: "curdForm.changeReason"
    }
  })], 1), _vm._v(" "), (_vm.adjustFlag == '1') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "原计划周数"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择周数",
      "multiple": ""
    },
    on: {
      "change": _vm.yjhskzcChange
    },
    model: {
      value: (_vm.curdForm.yjhskzc),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "yjhskzc", $$v)
      },
      expression: "curdForm.yjhskzc"
    }
  }, _vm._l((_vm.yjhskzcInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原计划星期"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择星期"
    },
    on: {
      "change": _vm.yjhxqChange
    },
    model: {
      value: (_vm.curdForm.yjhxq),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "yjhxq", $$v)
      },
      expression: "curdForm.yjhxq"
    }
  }, _vm._l((_vm.yjhxqInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原计划节数"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择节数",
      "multiple": ""
    },
    on: {
      "change": _vm.yjhsjxlChange
    },
    model: {
      value: (_vm.curdForm.yjhsjxl),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "yjhsjxl", $$v)
      },
      expression: "curdForm.yjhsjxl"
    }
  }, _vm._l((_vm.yjhsjxlInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "调整后周数"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择周数",
      "multiple": ""
    },
    on: {
      "change": _vm.tzhskzcChange
    },
    model: {
      value: (_vm.curdForm.tzhskzc),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "tzhskzc", $$v)
      },
      expression: "curdForm.tzhskzc"
    }
  }, _vm._l((_vm.tzhskzcInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "调整后星期"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择星期"
    },
    on: {
      "change": _vm.tzhxqChange
    },
    model: {
      value: (_vm.curdForm.tzhxq),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "tzhxq", $$v)
      },
      expression: "curdForm.tzhxq"
    }
  }, _vm._l((_vm.tzhxqInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "调整后节数"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择节数",
      "multiple": ""
    },
    on: {
      "change": _vm.tzhsjxlChange
    },
    model: {
      value: (_vm.curdForm.tzhsjxl),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "tzhsjxl", $$v)
      },
      expression: "curdForm.tzhsjxl"
    }
  }, _vm._l((_vm.tzhsjxlInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课教师"
    }
  }, [_c('span', {
    staticStyle: {
      "line-height": "40px"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.yjhskjsxm))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课地点"
    }
  }, [(_vm.sameFlag != 'true') ? _c('span', {
    staticStyle: {
      "line-height": "40px"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.yjhcdmc))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.yjhsiteList), function(site, i) {
    return _c('div', {}, [(_vm.sameFlag == 'true') ? _c('span', {
      staticStyle: {
        "line-height": "40px"
      }
    }, [_vm._v(_vm._s(_vm.yjhsiteList[i].name) + "  ===》")]) : _vm._e(), _vm._v(" "), (_vm.sameFlag == 'true') ? _c('el-select', {
      staticStyle: {
        "width": "90%"
      },
      attrs: {
        "filterable": "",
        "placeholder": "请选择授课地点"
      },
      on: {
        "change": function($event) {
          return _vm.siteChange(_vm.tzhsiteList[i].value, i)
        }
      },
      model: {
        value: (_vm.tzhsiteList[i].value),
        callback: function($$v) {
          _vm.$set(_vm.tzhsiteList[i], "value", $$v)
        },
        expression: "tzhsiteList[i].value"
      }
    }, _vm._l((_vm.tzhsiteInfo), function(item) {
      return _c('el-option', {
        key: item.comboValue,
        attrs: {
          "label": item.comboName,
          "value": item.comboValue
        }
      })
    }), 1) : _vm._e()], 1)
  })], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.adjustFlag == '4') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "代课周数"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择周数",
      "multiple": ""
    },
    on: {
      "change": _vm.yjhskzcChange
    },
    model: {
      value: (_vm.curdForm.yjhskzc),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "yjhskzc", $$v)
      },
      expression: "curdForm.yjhskzc"
    }
  }, _vm._l((_vm.yjhskzcInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代课星期"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择星期"
    },
    on: {
      "change": _vm.yjhxqChange
    },
    model: {
      value: (_vm.curdForm.yjhxq),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "yjhxq", $$v)
      },
      expression: "curdForm.yjhxq"
    }
  }, _vm._l((_vm.yjhxqInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代课节数"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择节数",
      "multiple": ""
    },
    on: {
      "change": _vm.yjhsjxlChange
    },
    model: {
      value: (_vm.curdForm.yjhsjxl),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "yjhsjxl", $$v)
      },
      expression: "curdForm.yjhsjxl"
    }
  }, _vm._l((_vm.yjhsjxlInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课教师"
    }
  }, [(_vm.sameFlag != 'true') ? _c('span', {
    staticStyle: {
      "line-height": "40px"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.yjhskjsbh))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.yjhteaList), function(tea, i) {
    return _c('div', {}, [(_vm.sameFlag == 'true') ? _c('span', {
      staticStyle: {
        "line-height": "40px"
      }
    }, [_vm._v(_vm._s(_vm.yjhteaList[i].name) + "  ===》")]) : _vm._e(), _vm._v(" "), (_vm.sameFlag == 'true') ? _c('el-select', {
      staticStyle: {
        "width": "90%"
      },
      attrs: {
        "filterable": "",
        "placeholder": "请选择授课地点"
      },
      on: {
        "change": function($event) {
          return _vm.teaChange(_vm.tzhteaList[i].value, i)
        }
      },
      model: {
        value: (_vm.tzhteaList[i].value),
        callback: function($$v) {
          _vm.$set(_vm.tzhteaList[i], "value", $$v)
        },
        expression: "tzhteaList[i].value"
      }
    }, _vm._l((_vm.tzhteacherInfo), function(item) {
      return _c('el-option', {
        key: item.comboValue,
        attrs: {
          "label": item.comboName,
          "value": item.comboValue
        }
      })
    }), 1) : _vm._e()], 1)
  })], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课地点"
    }
  }, [(_vm.sameFlag != 'true') ? _c('span', {
    staticStyle: {
      "line-height": "40px"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.yjhcdmc))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.yjhsiteList), function(site, i) {
    return _c('div', {}, [(_vm.sameFlag == 'true') ? _c('span', {
      staticStyle: {
        "line-height": "40px"
      }
    }, [_vm._v(_vm._s(_vm.yjhsiteList[i].name) + "  ===》")]) : _vm._e(), _vm._v(" "), (_vm.sameFlag == 'true') ? _c('el-select', {
      staticStyle: {
        "width": "90%"
      },
      attrs: {
        "filterable": "",
        "placeholder": "请选择授课地点"
      },
      on: {
        "change": function($event) {
          return _vm.siteChange(_vm.tzhsiteList[i].value, i)
        }
      },
      model: {
        value: (_vm.tzhsiteList[i].value),
        callback: function($$v) {
          _vm.$set(_vm.tzhsiteList[i], "value", $$v)
        },
        expression: "tzhsiteList[i].value"
      }
    }, _vm._l((_vm.tzhsiteInfo), function(item) {
      return _c('el-option', {
        key: item.comboValue,
        attrs: {
          "label": item.comboName,
          "value": item.comboValue
        }
      })
    }), 1) : _vm._e()], 1)
  })], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.adjustFlag == '3') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "补课周数"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择周数",
      "multiple": ""
    },
    on: {
      "change": _vm.tzhskzcChange
    },
    model: {
      value: (_vm.curdForm.tzhskzc),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "tzhskzc", $$v)
      },
      expression: "curdForm.tzhskzc"
    }
  }, _vm._l((_vm.tzhskzcInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "补课星期"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择星期"
    },
    on: {
      "change": _vm.tzhxqChange
    },
    model: {
      value: (_vm.curdForm.tzhxq),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "tzhxq", $$v)
      },
      expression: "curdForm.tzhxq"
    }
  }, _vm._l((_vm.tzhxqInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "补课节数"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择节数",
      "multiple": ""
    },
    on: {
      "change": _vm.tzhsjxlChange
    },
    model: {
      value: (_vm.curdForm.tzhsjxl),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "tzhsjxl", $$v)
      },
      expression: "curdForm.tzhsjxl"
    }
  }, _vm._l((_vm.tzhsjxlInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课教师"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择授课教师",
      "multiple": ""
    },
    model: {
      value: (_vm.curdForm.tzhskjsbh),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "tzhskjsbh", $$v)
      },
      expression: "curdForm.tzhskjsbh"
    }
  }, _vm._l((_vm.tzhteacherInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课地点"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择授课地点",
      "multiple": ""
    },
    model: {
      value: (_vm.curdForm.tzhcdbh),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "tzhcdbh", $$v)
      },
      expression: "curdForm.tzhcdbh"
    }
  }, _vm._l((_vm.tzhsiteInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.adjustFlag == '2') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "停课周数"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择周数",
      "multiple": ""
    },
    on: {
      "change": _vm.yjhskzcChange
    },
    model: {
      value: (_vm.curdForm.yjhskzc),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "yjhskzc", $$v)
      },
      expression: "curdForm.yjhskzc"
    }
  }, _vm._l((_vm.yjhskzcInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "停课星期"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择星期"
    },
    on: {
      "change": _vm.yjhxqChange
    },
    model: {
      value: (_vm.curdForm.yjhxq),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "yjhxq", $$v)
      },
      expression: "curdForm.yjhxq"
    }
  }, _vm._l((_vm.yjhxqInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "停课节数"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择节数",
      "multiple": ""
    },
    on: {
      "change": _vm.yjhsjxlChange
    },
    model: {
      value: (_vm.curdForm.yjhsjxl),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "yjhsjxl", $$v)
      },
      expression: "curdForm.yjhsjxl"
    }
  }, _vm._l((_vm.yjhsjxlInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课教师"
    }
  }, [_c('span', {
    staticStyle: {
      "line-height": "40px"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.yjhskjsxm))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课地点"
    }
  }, [_c('span', {
    staticStyle: {
      "line-height": "40px"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.yjhcdmc))])])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.editType == 'audit' || _vm.editType == 'show') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "申请类型",
      "prop": "applyType"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.curdForm.applyTypeName) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "申请教师",
      "prop": "applyTeacher"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.curdForm.applyTeacherName) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "专业名称",
      "prop": "majorCode"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.curdForm.majorName) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "班级名称",
      "prop": "classCode"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.curdForm.className) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程名称",
      "prop": "courseCode"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.curdForm.courseName) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "调课原因",
      "prop": "adjustReason"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.curdForm.adjustReasonName) + "\n                            "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadButton),
      expression: "uploadButton"
    }],
    staticStyle: {
      "margin-left": "50px"
    },
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": _vm.showUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-upload2"
  }), _vm._v(" 附件上传")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "变更理由",
      "prop": "changeReason"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.curdForm.changeReason) + "\n                        ")]), _vm._v(" "), (_vm.adjustFlag == '1') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "原计划周数"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.yjhskzc + '') + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原计划星期"
    }
  }, [_vm._v("\n                                " + _vm._s(parseInt(_vm.curdForm.yjhxq, 10)) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原计划节数"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.formatJS(_vm.curdForm.yjhsjxl + '')) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "调整后周数"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.tzhskzc + '') + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "调整后星期"
    }
  }, [_vm._v("\n                                " + _vm._s(parseInt(_vm.curdForm.tzhxq, 10)) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "调整后节数"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.formatJS(_vm.curdForm.tzhsjxl + '')) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课教师"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.yjhskjsxm + '') + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课地点"
    }
  }, _vm._l((_vm.yjhsiteList), function(site, i) {
    return _c('div', [_vm._v("\n                                    " + _vm._s(_vm.yjhsiteList[i].name + '') + " ===》 " + _vm._s(_vm.tzhsiteList[i].name + '') + "\n                                ")])
  }), 0)], 1) : _vm._e(), _vm._v(" "), (_vm.adjustFlag == '4') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "代课周数"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.yjhskzc + '') + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代课星期"
    }
  }, [_vm._v("\n                                " + _vm._s(parseInt(_vm.curdForm.yjhxq, 10)) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代课节数"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.formatJS(_vm.curdForm.yjhsjxl + '')) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课教师"
    }
  }, _vm._l((_vm.yjhteaList), function(site, i) {
    return _c('div', [_vm._v("\n                                    " + _vm._s(_vm.yjhteaList[i].name + '') + " ===》 " + _vm._s(_vm.tzhteaList[i].name + '') + "\n                                ")])
  }), 0), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课地点"
    }
  }, _vm._l((_vm.yjhsiteList), function(site, i) {
    return _c('div', [_vm._v("\n                                    " + _vm._s(_vm.yjhsiteList[i].name + '') + " ===》 " + _vm._s(_vm.tzhsiteList[i].name + '') + "\n                                ")])
  }), 0)], 1) : _vm._e(), _vm._v(" "), (_vm.adjustFlag == '3') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "补课周数"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.tzhskzc + '') + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "补课星期"
    }
  }, [_vm._v("\n                                " + _vm._s(parseInt(_vm.curdForm.tzhxq, 10)) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "补课节数"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.formatJS(_vm.curdForm.tzhsjxl + '')) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课教师"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.tzhskjsxm + '') + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课地点"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.tzhcdmc + '') + "\n                            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.adjustFlag == '2') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "停课周数"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.yjhskzc + '') + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "停课星期"
    }
  }, [_vm._v("\n                                " + _vm._s(parseInt(_vm.curdForm.yjhxq, 10)) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "停课节数"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.formatJS(_vm.curdForm.yjhsjxl + '')) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课教师"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.yjhskjsxm + '') + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课地点"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.yjhcdmc + '') + "\n                            ")])], 1) : _vm._e()], 1) : _vm._e()])], 1), _vm._v(" "), (_vm.operateButtonVisible) ? _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.auditDisabled == false && _vm.editType != 'show') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": function($event) {
        return _vm.saveInfo()
      }
    }
  }, [_vm._v("保 存")]) : _vm._e(), _vm._v(" "), (_vm.auditDisabled == false && _vm.editType != 'show') ? _c('el-button', {
    attrs: {
      "type": "warning",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": function($event) {
        return _vm.submitRec()
      }
    }
  }, [_vm._v("提 交")]) : _vm._e(), _vm._v(" "), (_vm.auditDisabled == true && _vm.editType != 'show' && _vm.applyused == false) ? _c('el-button', {
    attrs: {
      "disabled": _vm.applyused,
      "type": "warning",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": function($event) {
        return _vm.auditOption();
      }
    }
  }, [_vm._v("审核意见")]) : _vm._e(), _vm._v(" "), (_vm.editType != 'show') ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "top": "50px"
    },
    attrs: {
      "title": "附件上传",
      "visible": _vm.attachmentVisible,
      "width": "90%",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.attachmentVisible = $event
      },
      "close": _vm.closeAttachDialog
    }
  }, [_c('div', {
    staticStyle: {
      "height": "360px"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.fileTableLoading),
      expression: "fileTableLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "multipleTable",
    staticStyle: {
      "width": "300px",
      "margin-top": "15px"
    },
    attrs: {
      "data": _vm.fileTableData,
      "element-loading-text": "数据加载中",
      "height": _vm.fileTableHeight,
      "stripe": "",
      "border": "",
      "fit": ""
    }
  }, [(_vm.operateAreaVisible) ? _c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文件名",
      "prop": "fileName",
      "align": "center",
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "类型",
      "prop": "fileType",
      "align": "center",
      "width": "50px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "90px"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.operateAreaVisible),
            expression: "operateAreaVisible"
          }]
        }, [_c('div', [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "success"
          },
          on: {
            "click": _vm.clickUpload
          }
        }, [_c('i', {
          staticClass: "el-icon-upload2"
        }), _vm._v(" 上传")])], 1), _vm._v(" "), _c('div', {
          staticStyle: {
            "margin-top": "5px"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": _vm.confirmDelFile
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除")])], 1)]), _vm._v(" "), (_vm.viewAreaVisible) ? _c('div', [_vm._v("操作")]) : _vm._e()]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showAttachment(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v(" 预览\n                                ")])], 1), _vm._v(" "), _c('div', {
          staticStyle: {
            "margin-top": "5px"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.downloadAttachment(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-download"
        }), _vm._v(" 下载\n                                ")])], 1)]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "top": "50px"
    },
    attrs: {
      "title": "附件上传",
      "visible": _vm.uploadDialogVisible,
      "width": "360px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.uploadDialogVisible = $event
      },
      "close": _vm.closeUploadDialog
    }
  }, [_c('div', {
    staticClass: "attachmentUpload",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-upload', {
    ref: "uploadFile",
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": "#",
      "file-list": _vm.fileList,
      "http-request": _vm.getFile,
      "multiple": _vm.multipleType,
      "auto-upload": false,
      "limit": 10,
      "on-change": _vm.onChangeFile,
      "on-success": _vm.handleFilUploadSuccess,
      "on-remove": _vm.handleRemove,
      "on-exceed": _vm.handleExceed
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('div', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                                    允许上传的文件类型如下（单个文件大小" + _vm._s(_vm.fileSizeLimit) + "MB以内）"), _c('br'), _vm._v("\n                                    文本文件：txt、doc、docx、xls、xlsx、pdf、ppt、pptx"), _c('br'), _vm._v("\n                                    图片文件：jpg、jpeg、png、gif"), _c('br'), _vm._v("\n                                    音/视频文件：mp3、mp4\n                                ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": ""
    }
  }, [_vm._v("查看上传文件限制")])], 1)], 1)])])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleUpload
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.closeUploadDialog
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), (_vm.detailDialogVisible) ? _c('el-dialog', {
    staticClass: "formDialog xsyjDialog",
    attrs: {
      "title": _vm.detailDialogTitle,
      "visible": _vm.detailDialogVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.detailDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "10px",
      "height": "160px"
    }
  }, [_c('audit', {
    key: _vm.timer,
    ref: "audit",
    attrs: {
      "itemCode": _vm.queryForm.itemCode,
      "relatedCode": _vm.selectRowData.id,
      "auditLevel": _vm.curdForm.auditLevel
    },
    on: {
      "auditCallback": _vm.auditCallback
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.auditListDialogVisible) ? _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "title": "审核信息",
      "visible": _vm.auditListDialogVisible,
      "width": "90%",
      "top": "150px"
    },
    on: {
      "update:visible": function($event) {
        _vm.auditListDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "550px"
    }
  }, [_c('auditList', {
    ref: "auditList",
    attrs: {
      "relatedCode": _vm.selectRowData.id,
      "listHeight": 350,
      "auditFlowInfo": _vm.auditFlowInfo
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.previewerDialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": _vm.fileName,
      "visible": _vm.previewerDialogVisible,
      "width": "90%",
      "top": "80px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.previewerDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('previewer', {
    ref: "previewer",
    attrs: {
      "fileInfo": _vm.fileInfo,
      "height": 600
    }
  })], 1)]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "maskStyle",
    attrs: {
      "id": "loadingMask"
    }
  }, [_c('div', {
    staticClass: "maskFont"
  }, [_vm._v("调课信息保存中，请稍候...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-579444f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/adjustClasses.vue
// module id = 1834
// module chunks = 502